/**
 * The cluster center's trend is a volume-weighted average of rank deltas, so it
 * lands on fractions where a keyword's trend — plain integer subtraction of two
 * rank positions — never can. Rounding alone leaves it ragged (-13.8 beside
 * -14.45), so the center's values are fixed to two decimals. Keyword trends stay
 * whole numbers: padding them to "8.00" would be precision they don't have.
 */
export const CENTER_TREND_DECIMALS = 2;

// Rounds first so the sign follows the displayed value: 0.003 must read "0.00", not "+0.00", and -0.004 must not become "-0.00" (`|| 0` turns -0 into 0).
const roundCenterTrend = (trend: number): number =>
  Number(trend.toFixed(CENTER_TREND_DECIMALS)) || 0;

/** The center's trend as a bare number, for exports that stay numeric. */
export const formatCenterTrendValue = (trend: number): string =>
  roundCenterTrend(trend).toFixed(CENTER_TREND_DECIMALS);

/** The center's trend with an explicit + sign for gains, for display. */
export const formatCenterTrendNumber = (trend: number): string => {
  const rounded = roundCenterTrend(trend);
  const text = rounded.toFixed(CENTER_TREND_DECIMALS);
  return rounded > 0 ? `+${text}` : text;
};
